<div class="map-container">

  <div *ngIf="this.showRange" class="range-container">
    <!-- <input type="range" [(ngModel)]="this.rangeValue" (change)="this.onSliderChange()" min="1000" max="30000" step="100"> -->
    <ngx-slider [(value)]="this.rangeValue" [options]="this.rangeOptions" (userChangeEnd)="this.onSliderChange()" class="range-slider"></ngx-slider>
  </div>

  <div id="searchBarMap" class="map" *ngIf="this.showMap" #map></div>

  <div class="boxMap" #boxMap>

    <div class="mode-selectors p-3 d-flex align-items-center justify-content-between">
      <p class="m-0 p-0 me-2">Seleziona modalità:</p>
      <div class="mode-selector mx-2" [class.active]="this.metodo===2" (click)="this.changeMode(2)">
          <i class="icon-street-view"></i>
      </div>
      <div class="mode-selector mx-2" [class.active]="this.metodo===3" (click)="this.changeMode(3)">
          <i class="icon-map-pin"></i>
      </div>
      <div class="mode-selector mx-2" [class.active]="this.metodo===4" (click)="this.changeMode(4)">
          <i class="icon-draw-polygon"></i>
      </div>
    </div>

    <p class="title-map">
      {{this.metodo == 2 ? 'Vicino a te o a un punto' : this.metodo == 3 ? 'Zone su mappa' : 'Disegna area su mappa'}}
      <i class="icon-times cursor-pointer" (click)="this.close()"></i>
    </p>


    <div class="container-padding d-flex align-items-start justify-content-start flex-column h-100">
      <button class="btn btn-outline-primary mb-2 mt-0 showMobileCityZones" *ngIf="this.isCityWithZone" (click)="this.toggleMobileZones()">
        {{this.citySelected.name | titlecase}}: elenco zone
      </button>

      <div class="method-3-slider">

        <div class="search-badge" *ngIf="this.selectedFeatures?.length > 0 && this.placeholder && this.metodo!==3">
          <p>
            <i class="fas me-1" [class.icon-draw-polygon]="this.metodo == 4" [class.icon-street-view]="this.metodo == 2"></i>
            {{placeholder}}
          </p>
          <i class="icon-close icon-times" (click)="this.resetSelection(true)" *ngIf="this.metodo!==3"></i>
          <i class="icon-close icon-times" (click)="this.removePolygon(feature, feature.polygon, feature.layer)" *ngIf="this.metodo===3"></i>
        </div>

        <ng-container *ngIf="this.selectedFeatures?.length > 0 && this.placeholder && this.metodo===3">
          <ng-container *ngIf="!this.isCityWithZone">
            <div class="search-badge" *ngFor="let feature of this.selectedFeatures; let i=index">
              <p>
                <i class="me-1 icon-map-pin"></i>
                Zona selezionata:
                {{feature.properties.name}}
              </p>
              <i class="icon-close icon-times" (click)="this.removePolygon(feature, feature.polygon, feature.layer)"></i>
            </div>
          </ng-container>
          <ng-container *ngIf="this.isCityWithZone">
            <div class="search-badge">
              <p>
                <i class="me-1 icon-map-pin"></i>
                Zona selezionata:
                {{this.citySelected.name}}
                <ng-container *ngIf="this.countChildrensSelected()">({{this.countChildrensSelected()}} {{this.countChildrensSelected()>1?'Zone':'Zona'}})</ng-container>
              </p>
              <i class="icon-close icon-times" (click)="this.resetCitySelected()"></i>
            </div>
            <div class="search-badge" *ngFor="let feature of this.selectedFeaturesWithoutChildren(); let i=index">
              <p>
                <i class="me-1 icon-map-pin"></i>
                Zona selezionata:
                {{feature.properties.name}}
              </p>
              <i class="icon-close icon-times" (click)="this.clickOnPolygon(feature, feature.polygon, feature.layer)"></i>
            </div>
          </ng-container>
        </ng-container>

      </div>

      <input type="text" class="search-address" [placeholder]="this.metodo === 3 ? 'Inserisci città, comune o zona' : 'Inserisci un indirizzo su cui posizionare la mappa'" (keyup)="this.searchLocation($event.target.value)" id="search-address-input" (click)="this.untouched=false" #inputSuggestion />

      <div class="search-box-loading" *ngIf="this.searchLoading">
        <app-loading [height]="20" [width]="20"></app-loading>
        <p>Caricamento...</p>
      </div>
      <ng-container *ngIf="!this.searchLoading">
        <p *ngFor="let item of this.searchListSuggestions" (click)="this.clickSearchItem(item, true); this.inputSuggestion.value=''" class="suggestion-item">
          <i class="icon-map-marker-alt me-1"></i>
          {{item.name}} <ng-container *ngIf="item.type != 'Google'">• {{item.type}}</ng-container>

          <ng-container *ngIf="(this.metodo == 2 || this.metodo == 4) && item.properties?.comune_name != item.name">• {{item.properties?.comune_name}} </ng-container>
          <ng-container *ngIf="(this.metodo == 2 || this.metodo == 4) && item.properties?.name != item.properties?.prov_acr">• {{item.properties?.prov_acr}}</ng-container>
        </p>
        <p *ngIf="this.searchListSuggestions && this.searchListSuggestions.length == 0" class="suggestion-item">
          <i class="icon-exclamation-triangle me-1"></i>
          Nessun risultato
        </p>
      </ng-container>

      <p *ngIf="this.userLocationFail && this.untouched" class="text-danger fw-bold py-2 px-1 m-0">{{this.userLocationFail}}</p>

      <button class="btn btn-primary" (click)="this.handleClick()" [disabled]="this.selectedFeatures?.length == 0 && !this.mobile">
        {{this.getSearchLabel()}}
      </button>

      <ul *ngIf="this.showZones() && this.isCityWithZone" class="zones">
          <li>
              <div class="option">
                  <label class="m-0 p-0 w-100 d-flex align-items-center justify-content-start cursor-pointer" for="map-tutte-le-zone">
                      <input type="checkbox" name="tutte-le-zone" id="map-tutte-le-zone" class="me-2" (change)="this.selectAllCityZones($event)" [checked]="this.checkNoZoneSelected()">
                      <span>Tutte le zone</span>
                      <i class="fas clearField" [class.icon-chevron-down]="!this.showCityZones" [class.icon-chevron-up]="this.showCityZones" (click)="this.showCityZones = !this.showCityZones; $event.stopPropagation()"></i>
                  </label>
              </div>
          </li>
          <ng-container *ngIf="this.showCityZones">
            <li *ngFor="let zone of this.showZones()">
              <div class="option">
                  <label class="m-0 p-0 w-100 d-flex align-items-center justify-content-start cursor-pointer" [for]="'map-'+zone.name">
                      <input type="checkbox" [name]="zone.name" [id]="'map-'+zone.name" class="me-2" (change)="this.clickOnCityZone(zone.name)" [checked]="this.checkSelectedZones(zone.name)">
                      <span>{{zone.display_name}}</span>
                  </label>
              </div>
            </li>
          </ng-container>
      </ul>


      <div class="patina-loading" *ngIf="this.mapLoading">
        <app-loading [fill]="'#ffffff'"></app-loading>
        <p class="p-0 m-0">Sto caricando la mappa</p>
      </div>
    </div>

  </div>

  <ul *ngIf="this.showZones() && this.isCityWithZone && this.showMobileCityList" class="mobile-zones">
    <div class="header"><p class="text-align-center">Seleziona una o più zone</p></div>
    <div class="body">
      <li>
        <div class="option">
            <label class="m-0 p-0 w-100 d-flex align-items-center justify-content-start cursor-pointer" for="map-tutte-le-zone">
                <input type="checkbox" name="tutte-le-zone" id="map-tutte-le-zone" class="me-2" (change)="this.selectAllCityZones($event)" [checked]="this.checkNoZoneSelected()">
                <span>Tutte le zone</span>
            </label>
        </div>
      </li>
      <li *ngFor="let zone of this.showZones()">
          <div class="option">
              <label class="m-0 p-0 w-100 d-flex align-items-center justify-content-start cursor-pointer" [for]="'map-'+zone.name">
                  <input type="checkbox" [name]="zone.name" [id]="'map-'+zone.name" class="me-2" (change)="this.clickOnCityZone(zone.name)" [checked]="this.checkSelectedZones(zone.name)">
                  <span>{{zone.display_name}}</span>
              </label>
          </div>
      </li>
    </div>
    <div class="footer"><button class="btn btn-primary w-100" (click)="this.toggleMobileZones()">Conferma</button></div>
  </ul>

</div>

<div class="metodo-4-disclaimer" *ngIf="this.metodo === 4 && !this.mobile && this.drawPolygon && this.drawPolygon._markers">
  <div class="metodo-4-disclaimer__content" (click)="logDP()">
    <p *ngIf="!hasSearchedAddress && !this.drawPolygon._markers.length>0">Inserisci un indirizzo su cui posizionare la mappa</p>
    <p *ngIf="this.drawPolygon._markers.length===0 && hasSearchedAddress">Fai click sulla mappa e disegna il poligono</p>
    <p *ngIf="this.drawPolygon._markers.length>0 && this.drawPolygon._markers.length<=2">Continua a cliccare per disegnare i punti del poligono</p>
    <p *ngIf="this.drawPolygon._markers.length>2">Chiudi il poligono cliccando sul primo punto</p>
  </div>
</div>
